<template>
    <div class="container">
        <Index
            v-if='indexshow'
            @nextpage='nextpage'>
        </Index>
        <result v-if='resultshow'></result>
    </div>
</template>

<script>
import Index from './components/Index';
import result from './components/result';

export default {
    components: {
        Index,
        result
    },
    data() {
        return {
            indexshow: true,
            resultshow: false
        };
    },
    methods: {
        nextpage() {
            this.indexshow = false;
            this.resultshow = true;
        }
    },
    mounted() {
    },
    created() {
    }
};
</script>

<style lang="stylus">
</style>
